import { Check } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { CAMPAIGN } from "@/config/campaign";

export const Bonus = () => (
  <section className="bg-offwhite py-16 md:py-24" data-testid="bonus-section">
    <div className="mx-auto grid max-w-[1180px] grid-cols-1 items-center gap-10 px-5 lg:grid-cols-2">
      <Reveal>
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-gold-dark">Garantierter Sofortbonus</p>
        <h2 className="mt-3 font-display text-4xl font-extrabold tracking-tight text-ink md:text-5xl">
          {CAMPAIGN.bonusName}.
        </h2>
        <p className="mt-4 max-w-lg text-base text-mutedlight">
          Kein Gewinnspiel-Glück nötig: Jeder gültige Teilnehmer erhält das Sparpaket sofort nach der Anmeldung per E-Mail.
        </p>
        <ul className="mt-6 space-y-2.5" data-testid="bonus-benefit-list">
          {["23 Prüfpunkte", "Unterlagen-Checkliste", "5-Minuten-Steuercheck", "Finaler Einreichungscheck"].map((b) => (
            <li key={b} className="flex items-center gap-2.5 text-sm font-medium text-ink">
              <Check className="h-4 w-4 shrink-0 text-gold-dark" strokeWidth={3} /> {b}
            </li>
          ))}
        </ul>
      </Reveal>
      <Reveal delay={0.15}>
        <div className="relative mx-auto max-w-[340px]" data-testid="bonus-mockup">
          <div className="absolute -inset-4 rounded-[24px] bg-gold/15 blur-2xl" aria-hidden="true" />
          <img
            src="/bonus-sparpaket-preview.png"
            alt="Vorschau: ChickenWinner Steuer-Sparpaket 2027 (PDF)"
            className="relative w-full rounded-[14px] border border-line shadow-[0_24px_60px_rgba(17,17,17,0.18)]"
            loading="lazy"
          />
        </div>
      </Reveal>
    </div>
  </section>
);
